import {DateRangePicker} from "react-date-range";
import {useEffect, useState} from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import {de, enUS, vi} from 'date-fns/locale'
import dayjs from "dayjs";
import {Button, Col, Row} from "antd";
import {KeyConstant} from "../constant/keyConstant";
import {staticRanges} from "../common/staticRanges";
import {useSearchParams} from "react-router-dom";
import {t} from "i18next";
import {getLanguage} from "../../../../custom/axios";

const styleRow = {
    borderTop: "1px solid #EAECF0"
}

export const getLanguageDateRangerPicker = () =>{
    const lang = getLanguage()
    if (lang === "vi") return vi
    if (lang === "en") return enUS
    if (lang === "de") return de
    return null
}

const format = "YYYYMMDD"
const CalendarModal = ({onCancel, destroy, onDestroy, onSubmit, objectParam}) => {

    const [searchParams] = useSearchParams()
    const [selectedDateRange, setSelectedDateRange] = useState({
        startDate: dayjs().subtract(28, "days").toDate(),
        endDate: dayjs().subtract(1, "days").toDate(),
        key: "selection"
    });

    const [type, setType] = useState(KeyConstant.THIRTY_DAYS_AGO)
    const [checkCustom, setCheckCustom] = useState(false)

    const [selectedDateRangeTemp, setSelectedDateRangeTemp] = useState({
        startDate: dayjs().subtract(28, "days").toDate(),
        endDate: dayjs().subtract(1, "days").toDate(),
        key: "selection"
    });
    const [typeTemp, setTypeTemp] = useState(KeyConstant.THIRTY_DAYS_AGO)
    const [checkCustomTemp, setCheckCustomTemp] = useState(false)

    useEffect(() => {

        let range = {
            startDate: dayjs(objectParam?.startDate).toDate(),
            endDate: dayjs(objectParam?.endDate).toDate(),
            key: "selection"
        }
        setSelectedDateRange(range)
        setType(objectParam?.type ? objectParam.type   : KeyConstant.THIRTY_DAYS_AGO)
        setCheckCustom(checkCustomFromRange(range))


        setSelectedDateRangeTemp({
            startDate: dayjs(objectParam?.startDate).toDate(),
            endDate:  dayjs(objectParam?.endDate).toDate(),
            key: "selection"
        })

        setTypeTemp(objectParam?.type ? objectParam.type   : KeyConstant.THIRTY_DAYS_AGO)
        setCheckCustomTemp(checkCustomFromRange(range))
    }, [searchParams])



    useEffect(() => {
        if (destroy) {
            convert()
            onDestroy()
            onCancel()
        }
    }, [destroy])


    const checkCustomFromRange = (range) => {
        if (dayjs(range.startDate).format(format) === dayjs(range.endDate).format(format) &&
            dayjs(range.startDate).format(format) === dayjs().format(format)) {
            return false
        }
        if (dayjs(range.startDate).format(format) === dayjs(range.endDate).format(format) &&
            dayjs(range.startDate).format(format) === dayjs().subtract(1, "days").format(format)) {
            return false
        }
        if (dayjs(range.startDate).format(format) === dayjs().startOf("week").format(format) &&
            dayjs(range.endDate).format(format) === dayjs().endOf("week").format(format)) {
            return false
        }
        if (dayjs(range.startDate).format(format) === dayjs().subtract(1, "weeks").startOf("week").format(format) &&
            dayjs(range.endDate).format(format) === dayjs().subtract(1, "weeks").endOf("week").format(format)) {
            return false
        }
        if (dayjs(range.startDate).format(format) === dayjs().startOf("month").format(format) &&
            dayjs(range.endDate).format(format) === dayjs().endOf("month").format(format)) {
            return false
        }
        if (dayjs(range.startDate).format(format) === dayjs().subtract(1, "month").startOf("month").format(format) &&
            dayjs(range.endDate).format(format) === dayjs().subtract(1, "month").endOf("month").format(format)) {
            return false
        }
        if (dayjs(range.startDate).format(format) === dayjs().subtract(7, "days").format(format) &&
            dayjs(range.endDate).format(format) === dayjs().subtract(1, "days").format(format)) {
            return false
        }
        if (dayjs(range.startDate).format(format) === dayjs().subtract(28, "days").format(format) &&
            dayjs(range.endDate).format(format) === dayjs().subtract(1, "days").format(format)) {
            return false
        }
        return !(dayjs(range.startDate).format(format) === dayjs().subtract(90, "days").format(format) &&
            dayjs(range.endDate).format(format) === dayjs().subtract(1, "days").format(format))

    }
    const handleSelect = ranges => {
        setCheckCustom(checkCustomFromRange(ranges.selection))
        setType(ranges.selection.text || KeyConstant.CUSTOM)
        delete ranges.selection.text;
        setSelectedDateRange(ranges.selection);
    };
    const cancel = () => {
        onCancel()
    }

    const submit = () => {

        // searchParams.delete(KeyFilter.START_DATE)
        // if (selectedDateRange.startDate) {
        //     searchParams.append(KeyFilter.START_DATE, selectedDateRange.startDate)
        // }
        //
        // searchParams.delete(KeyFilter.END_DATE)
        // if (selectedDateRange.endDate) {
        //     searchParams.append(KeyFilter.END_DATE, selectedDateRange.endDate)
        // }
        // searchParams.delete("type")
        // if (type) {
        //     searchParams.append("type", type)
        // }
        //
        // navigate(`?${searchParams.toString()}`)
        //
        // dispatch(onReloadData(!reloadData))

        onSubmit(selectedDateRange.startDate, selectedDateRange.endDate,type)

        onCancel()
    }

    const convert = () => {
        setSelectedDateRange(selectedDateRangeTemp)
        setType(typeTemp)
        setCheckCustom(checkCustomTemp)
    }

    useEffect(() => {
        if (destroy) {
            convert()
            onDestroy()
            onCancel()
        }
    }, [destroy])

    return (
        <>
            <DateRangePicker
                onChange={handleSelect}
                months={2}
                ranges={[selectedDateRange]}
                direction="horizontal"
                locale={getLanguageDateRangerPicker()}
                staticRanges={staticRanges}
                inputRanges={[]}
                dateDisplayFormat={"dd/MM/yyyy"}
                monthDisplayFormat={"MM/yyyy"}
                showDateDisplay={false}
                fixedHeight={true}
                color={["red"]}
            />

            <Row>
                <Col span={24}
                     style={{
                         padding: "10px 20px",
                         color: checkCustom ? "var(--primary-color)" : "",
                         fontWeight: checkCustom ? 600 : 400,
                         fontFamily: "'Open Sans', sans-serif",
                         fontSize: 13
                     }}>
                    {t("tnp.components.report.custom")}
                </Col>
            </Row>

            <Row style={styleRow}>
                <Col span={20}/>
                <Col span={4} className={"pt-6"}>
                    <div className={"flex items-center"}>
                        <Button className={"mr-3"} onClick={cancel}>
                            {t("common.cancel")}
                        </Button>
                        <Button type="primary" onClick={submit}>
                            {t("tnp.components.timekeeping.text7")}
                        </Button>
                    </div>
                </Col>
            </Row>

        </>
    )
}

export default CalendarModal
